import { Link } from "react-router-dom"
import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { Dropdown, NavDropdown } from "react-bootstrap"
import navImg from '../assets/Parker Bond Program logo Full Color 2.png'
import NavbarLine from "./NavbarLine";
import projects from '../components/Projects.json'
import { CalendarIcon, CarIcon, ChartIcon, ContactIcon, HomeIcon, InfoIcon, MapIcon } from "../assets/icons";

export default function Navbar() {

    const location = useLocation();

    const { pathname } = location;

    const splitLocation = pathname.split("/");

    const [projectList, setProjectList] = useState([]);

    const initData = () => {

        projects.sort((a, b) => {
            return new String(a.number).slice(0, 4) - new String(b.number).slice(0, 4);
        })
        
        setProjectList(projects.map((li) => {
            return <NavbarLine key={li.id} title={li.title} id={li.id} number={li.number} />
        }))
    }

    useEffect(() => {
        initData()
    }, [])

    return (
        <div>
            <nav className="navbar navbar-expand-lg" style={{ backgroundColor: 'white' }}>
                <div className="container justify-content-between">
                    <a className="navbar-brand">
                        <img src={navImg} style={{ height: "95px" }} draggable="false" alt="Parker County" />
                        {/*<h3 className="d-none d-lg-inline ms-3" id="navbarH3" style={{ verticalAlign: "middle" }}>2023 Parker County Transportation Bond Program</h3>*/}
                    </a>

                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
            </nav>
            <nav className="navbar navbar-expand-lg navbar-dark py-0 shadow-sm" style={{ backgroundColor: '#4668a0' }}>
                <div className="container">
                    <div className="collapse navbar-collapse" id="navbarCollapse">
                        <div className="navbar-nav fw-medium justify-content-center w-100" style={{ fontSize: "20px" }}>
                            <Link className="nav-link me-3" id={(splitLocation[1] === "" ? "active" : "notActive")} to="/" ><HomeIcon />Home</Link>
                            <Link className="nav-link me-3" id={(splitLocation[1] === "traffic" ? "active" : "notActive")} to="/traffic"> <CarIcon /> Traffic Updates</Link>
                            <Link className="nav-link me-3" id={(splitLocation[1] === "reports" ? "active" : "notActive")} to="/reports"><ChartIcon /> Reports</Link>
                            <Link className="nav-link me-3" id={(splitLocation[1] === "projects" ? "active" : "notActive")} to="/projects"><MapIcon /> Projects Map</Link>
                            <li className="nav-item dropdown me-3" >
                                <div className="nav-link dropdown-toggle bold" id={(splitLocation[1] === "viewprojects" ? "active" : "notActive")} role="button" data-bs-toggle="dropdown">
                                    <InfoIcon />Projects
                                </div>
                                <ul className="dropdown-menu fw-bold" style={{ overflowY: "scroll", height: "600px" }}>
                                    {projectList}
                                </ul>
                            </li>
                            <a className="nav-link " href="mailto:Info@parkercountybond.com" title="Email us at Info@parkercountybond.com" style={{ color: "white", textDecoration: "none" }}>
                                <ContactIcon /> Contact Us
                            </a>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    )
}